// @flow

import siteSettings from './reducers';

export { receivedSiteSettings } from './actions';
export {
  getGoogleSiteVerification,
  getMainMenuMoreLabel,
  getGtmCode,
  getLogo,
  getScripts,
  getHasVbmrEnabled,
  getIsThuiswinkelLogoVisible,
} from './selectors';
export type { State } from './reducers';

export default siteSettings;
